import * as types from 'store/moderatorList/moderatorListTypes'

const initialState = {
  moderatorList: [],
  noModerators: false,
  allModerators: []
}

const moderatorListReducer = (state = initialState, action) => {

  switch (action.type) {
    case types.FETCH_ALL_MODERATORS_SUCCEEDED:
      console.log("inside fetch moderatorList succeeded ",action)
      return {
        ...state,
        moderatorList: action.payload.data,
        noModerators: action.payload.data.length === 0 ? true : false
      }
      case types.FETCH_ALL_MODERATORS_WITHOUT_CLIENT_ID_SUCCEEDED:
        return {
          ...state,
           allModerators: action.payload,
        }
    default:
      return state
  }
}

export default moderatorListReducer
